const { orderType, chargeCode, sourceAndDestinationType } = require("pando-constants");

class EccCharge {

  getMaxChargeOfConsigneeGroup(_group, consigneeGroup, amount) {
    let charge = 0;
    const group = _group;
    if (!group[consigneeGroup]) {
      group[consigneeGroup] = 0;
    }
    if (amount > group[consigneeGroup]) {
      charge = (amount - group[consigneeGroup]);
      group[consigneeGroup] = amount;
    }
    return charge;
  }

  ecc(data) {
    let eccCharge = 0;
    const group = {};
    if (data.orderType === orderType.CONTRACT) {
      const destinationEccCharges =
        data.indentDestinationCharges &&
        data.indentDestinationCharges.filter(
          charge => charge.charge_code === chargeCode.ECC
        );
      data.destinations.forEach(destination => {
        destinationEccCharges.forEach(destCharge => {
          if ( destCharge.destination_id && destination.locationId && destCharge.destination_id.toString() === destination.locationId.toString() ) {
            const amount = Math.max(destCharge.charges[0].charge, destCharge.charges[0].min_charge);
            eccCharge += (destination.type === sourceAndDestinationType.CONSIGNEE && destination.group && destination.group.length) ?
              this.getMaxChargeOfConsigneeGroup(group, destination.group, amount) : amount;
          }
        });
      });
    }
    return eccCharge;
  }
}

module.exports = EccCharge;